<script>
    import Card from '@/components/Card'

    export default {
        components: {
            Card,
        },

        mounted() {
            this.$root.restrictCountries('*')
            this.$store.commit('mainPage', {
                current: this.$t('Product families'),
                stack: [{
                    'path': '/product-families',
                    'title': this.$t('Product families'),
                }]
            })
        },
    }
</script>

<template>
    <section class="section">
        <div class="container-fluid">
            <card class="is-card-table has-pagination has-bottom-left-hidden">
                <bg-table-products :label="$t('Product families')" group-by="GroupId" group-data="Group"/>
            </card>
        </div>
    </section>
</template>
